import Dexie, { Table } from 'dexie';
import { DailyCountList } from '@bofrak-backend/shared';

export interface CachedDailyCountList extends DailyCountList {
  /** Local write timestamp (ms) used for cache freshness checks. */
  _cachedAt: number;
}

/**
 * Local IndexedDB cache for daily-count lists so the Daily Count tab renders
 * instantly from the previous session's data while the network refresh runs
 * in the background (important on slow shop-floor connections).
 */
class DailyCountDatabase extends Dexie {
  dailyCountLists!: Table<CachedDailyCountList, [string, string]>;

  constructor() {
    super('ShopAndSmileDailyCountDB');

    this.version(1).stores({
      dailyCountLists:
        '&[store_id+count_date], store_id, count_date, merchant_id',
    });
  }

  /**
   * @returns the cached list, `null` when nothing is cached for this
   * store+date (undefined is reserved by useLiveQuery for "still loading").
   */
  async getList(
    storeId: string,
    date: string,
  ): Promise<DailyCountList | null> {
    const cached = await this.dailyCountLists.get([storeId, date]);
    return cached ?? null;
  }

  async putList(list: DailyCountList): Promise<void> {
    await this.dailyCountLists.put({ ...list, _cachedAt: Date.now() });
  }
}

export const dailyCountDb = new DailyCountDatabase();
